import React from 'react';
import './styles/tokens.css';
import './styles/header.css';
import './styles/aside.css';
import './styles/outros.css';
import './styles/pages/form-arquetipo.css';
import './styles/pages/list-arquetipo.css';
import './styles/pages/form-empresas.css';
import './styles/pages/list-empresas.css';
import './styles/pages/form-config.css';
import './styles/pages/page-dashboard.css';
import './styles/pages/page-empty.css';
import './styles/pages/list-usuarios.css';
import './styles/pages/form-usuarios.css';
import './styles/pages/page-login.css';
import './styles/pages/page-approve.css';
import './styles/pages/page-newpayment.css';
import './styles/pages/page-batch-details.css';
import './styles/pages/list-creditores.css';
import './styles/pages/page-sync-logs.css';
import './styles/pages/page-payments.css';
import './styles/pages/page-payment-logs.css';
import { AppProvider, useApp } from './components/sp-shell';
import { CompanyPicker, DiffModal, PersistentErrorStack, ToastStack } from './components/sp-overlays';
import { PEmpty } from './pages/page-empty';
import { PLogin } from './pages/page-login';
import { PDashboard } from './pages/page-dashboard';
import { PNewPayment } from './pages/page-newpayment';
import { PApprove } from './pages/page-approve';
import { PPayments } from './pages/page-payments';
import { PPaymentLogs } from './pages/page-payment-logs';
import { PBatchDetails } from './pages/page-batch-details';
import { PCompanies } from './pages/list-empresas';
import { PCompanySyncLogs } from './pages/page-sync-logs';
import { PCompanyCreditors } from './pages/list-creditores';
import { PCompanyForm } from './pages/form-empresas';
import { PTemplates } from './pages/list-arquetipo';
import { PTemplateForm } from './pages/form-arquetipo';
import { PUsers } from './pages/list-usuarios';
import { PProfile } from './pages/form-usuarios';
import { PSettings } from './pages/form-config';
import { BODY_ID_BY_ROUTE, ROUTES } from './routes';

function Router() {
  const app = useApp();
  const isAdministrator = Array.isArray(app.currentUser?.permissions) && app.currentUser.permissions.includes('Administrador');
  const hasActiveCompany = app.companies.some((c) => String(c.status || '').toLowerCase() === 'active');
  const requiresActiveCompany = new Set([
    ROUTES.DASHBOARD,
    ROUTES.IMPORT,
    ROUTES.IMPORT_NEW,
    ROUTES.PAYMENT_NEW,
    ROUTES.APPROVE,
    ROUTES.PAYMENTS,
    ROUTES.DETAILS,
    ROUTES.BATCH_DETAILS,
    ROUTES.COMPANY_CREDITORS,
    ROUTES.COMPANY_SYNC_LOGS,
    ROUTES.PAYMENT_LOGS,
    ROUTES.TEMPLATES,
    ROUTES.TEMPLATE_NEW,
  ]);
  const shouldRenderEmptyForNoActiveCompany = (
    app.route !== ROUTES.LOGIN
    && app.route !== ROUTES.EMPTY
    && requiresActiveCompany.has(app.route)
    && !hasActiveCompany
  );

  React.useEffect(() => {
    const nextId = shouldRenderEmptyForNoActiveCompany
      ? BODY_ID_BY_ROUTE[ROUTES.EMPTY]
      : (BODY_ID_BY_ROUTE[app.route] || BODY_ID_BY_ROUTE[ROUTES.DASHBOARD]);
    document.body.id = nextId;
    document.body.setAttribute('data-page-route', app.route || ROUTES.DASHBOARD);
  }, [app.route, shouldRenderEmptyForNoActiveCompany]);

  if (shouldRenderEmptyForNoActiveCompany) {
    return <PEmpty />;
  }

  switch (app.route) {
    case ROUTES.LOGIN: return <PLogin />;
    case ROUTES.EMPTY: return <PEmpty />;
    case ROUTES.DASHBOARD: return <PDashboard />;
    case ROUTES.IMPORT:
    case ROUTES.IMPORT_NEW:
      return <PNewPayment />;
    case ROUTES.PAYMENT_NEW: return <PNewPayment />;
    case ROUTES.APPROVE: return <PApprove />;
    case ROUTES.PAYMENTS: return <PPayments />;
    case ROUTES.DETAILS:
    case ROUTES.BATCH_DETAILS:
      return <PBatchDetails />;
    case ROUTES.COMPANIES: return <PCompanies />;
    case ROUTES.COMPANY_SYNC_LOGS: return <PCompanySyncLogs />;
    case ROUTES.PAYMENT_LOGS: return <PPaymentLogs />;
    case ROUTES.COMPANY_CREDITORS: return <PCompanyCreditors />;
    case ROUTES.COMPANY_NEW: return <PCompanyForm />;
    case ROUTES.TEMPLATES: return <PTemplates />;
    case ROUTES.TEMPLATE_NEW: return <PTemplateForm />;
    case ROUTES.USERS: return <PUsers />;
    case ROUTES.PROFILE: return <PProfile />;
    case ROUTES.SETTINGS: return isAdministrator ? <PSettings /> : <PDashboard />;
    default: return <PDashboard />;
  }
}

function AppRoot() {
  return (
    <AppProvider>
      <Router />
      <CompanyPicker />
      <DiffModal />
      <PersistentErrorStack />
      <ToastStack />
    </AppProvider>
  );
}

export { AppRoot };
